<template lang="pug">
  div
</template>

<script>

export default {
  components: {

  },
  props: {
    provider: {
      required: true,
      type: String
    }
  },
  created () {
    document.location.href = `https://api.feature.watch/auth/${this.provider}`
  }
}
</script>
